'use client';

import { JSX, createContext, useContext, useState, PropsWithChildren } from 'react';

export const DEFAULT_SUBMIT_TEXT = 'Create Account';

export type SignUpContext = {
    error?: string | undefined;
    setError: (error: string | undefined) => void;
    submitText: string;
    setSubmitText: (text: string) => void;
};
const context = createContext<SignUpContext>({
    setError: () => {},
    setSubmitText: () => {},
    submitText: DEFAULT_SUBMIT_TEXT,
});

export function SignUpContextProvider({ children }: PropsWithChildren): JSX.Element {
    const [error, setError] = useState<string | undefined>(undefined);
    const [submitText, setSubmitText] = useState<string>(DEFAULT_SUBMIT_TEXT);

    return <context.Provider value={{ error, setError, submitText, setSubmitText }}>{children}</context.Provider>;
}

export const useSignUpContext = (): SignUpContext => useContext(context);
